import { render } from "./Volunteers.vue?vue&type=template&id=b2f0b65c&scoped=true"
import script from "./Volunteers.vue?vue&type=script&lang=js"
export * from "./Volunteers.vue?vue&type=script&lang=js"

import "./Volunteers.vue?vue&type=style&index=0&id=b2f0b65c&scoped=true&lang=css"
import "./Volunteers.vue?vue&type=style&index=1&id=b2f0b65c&lang=css"
import "./Volunteers.vue?vue&type=style&index=2&id=b2f0b65c&scoped=true&lang=css"
import "./Volunteers.vue?vue&type=style&index=3&id=b2f0b65c&lang=css"
import "./Volunteers.vue?vue&type=style&index=4&id=b2f0b65c&lang=css"
import "./Volunteers.vue?vue&type=style&index=5&id=b2f0b65c&scoped=true&lang=css"
import "./Volunteers.vue?vue&type=style&index=6&id=b2f0b65c&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f0b65c"]])

export default __exports__